module.exports = new __parcel__URL__("hontar.7410e973.jpg").toString();